import { useEffect, useMemo, useState } from 'react';
import { useRunRequest } from '@/hooks';
import { TurnResourcesEnum, TurnTargetsEnum } from '@/types/turn-enums';
import { TurnAdminStateCounty } from '@/types/turn-api';
import { PAGINATION_OPTIONS } from './constants';
import { CountyInputProps } from './types';

const useController = ({ state }: CountyInputProps) => {
  const { runRequest } = useRunRequest();
  const [counties, setCounties] = useState<TurnAdminStateCounty[]>([]);

  const isDisabled = useMemo(() => !state || counties.length === 0, [state, counties]);

  const getCounties = async () => {
    const response = await runRequest({
      fetchType: 'GET_LIST',
      resource: TurnResourcesEnum.TurnAdminStates,
      params: {
        id: state,
        target: TurnTargetsEnum.Counties,
        pagination: PAGINATION_OPTIONS,
      },
      mode: 'silent',
    });

    setCounties(response.data);
  };

  useEffect(() => {
    if (!state) return;
    getCounties();
  }, [state]);

  return {
    counties,
    isDisabled,
  };
};

export default useController;
